<div class="auth__inner">
  <a href="javascript:void(0);" class="brand-logo">
    <img
      src="{{ coreConfig.app.appLogoImage }}"
      alt="brand-logo"
      height="164"
      width="164"
    />
  </a>

  <router-outlet></router-outlet>

  <language-selection class="mt-2"></language-selection>
</div>
